import { render, staticRenderFns } from "./dianbofangnew.vue?vue&type=template&id=2c09d038&scoped=true"
import script from "./dianbofangnew.vue?vue&type=script&lang=js"
export * from "./dianbofangnew.vue?vue&type=script&lang=js"
import style0 from "./dianbofangnew.vue?vue&type=style&index=0&id=2c09d038&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c09d038",
  null
  
)

export default component.exports